import { engineComponent } from "neo-common";
import { ComponentTypes } from "../../Components/ComponentTypes";
import { BaseUserControls } from "../Common/UserControls/BaseUserControls";
import { HtmlController } from "../../HTMLComponents/HtmlController";

@engineComponent(ComponentTypes.HtmlElement)
export class DesktopBaseUserControls extends BaseUserControls {
    //disable base without reseting timer and win animations in winAnimator
    //used in frb, to avoid not showing end message in last frb spin with win
    protected disableAllActions(): void {
        this._afterWinDelay.stop();
        this.actions.disableAllActions();
        HtmlController.updateActionElements(this.getAllActions());
    }
}



/** WEBPACK FOOTER **
 ** ./Engine/Game/Channels/Desktop/DesktopBaseUserControls.ts
 **/